//
// KeyFrameValueOptions.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/GTLModel";
import "@sas-dvr/ltjs-commons/util/Dimension";
import "../core/styles/TextAttributes";
import "../core/HorizontalAlignment";
import "../core/VerticalAlignment";

var KeyFrameValueOptions = createModule("gtl::KeyFrameValueOptions", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        padding: 1,
        textAttributes: 1,
        fitWidth: 1,
        useFitWidth: 2,
    },
    ,
    {
        hAlign: 4,
        vAlign: 4,
    },
    {
        setStyle: [0,1],
    },
    {
        _create: [4],
    },
    ,
]);
export default KeyFrameValueOptions;
